let activeIndex = 0;
let onSectionOpenCallback = null; // Variable to hold the callback function

const setActiveIndex = (index) => {
  activeIndex = index;
};

const handleClick = (index, image) => {
  setActiveIndex(index);
  toggleAccordion(index);

  // Update background image and add fade-in effect
  const featuredLinksImage = document.querySelector('.featured-links-image');
  if (featuredLinksImage) {
    const backgroundFade = featuredLinksImage.querySelector('.background-fade');
    if (backgroundFade) {
      // Set opacity to 0, then add a slight delay before increasing opacity to 1
      backgroundFade.style.transition = 'opacity 0s';
      backgroundFade.style.opacity = 0;

      // Delay the fade-in transition by 10ms to ensure opacity change takes effect
      setTimeout(() => {
        backgroundFade.style.backgroundImage = `url(${image})`;
        backgroundFade.style.transition = 'opacity 0.5s ease-in-out';
        backgroundFade.style.opacity = 1;
      }, 10);
    }
  }

  // Call the provided callback function when a category is clicked
  if (onSectionOpenCallback) {
    onSectionOpenCallback(image);
  }
};

const initAccordion = (onSectionOpen) => {
  onSectionOpenCallback = onSectionOpen; // Store the callback function

  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach((item, index) => {
    const accordionTitle = item.querySelector('.accordion-title');

    // Remove any existing click event listeners to avoid duplicate attachments
    accordionTitle.removeEventListener('click', handleClick);

    // Attach the click event listener
    accordionTitle.addEventListener('click', () => {
      handleClick(index, item.getAttribute('data-image'));
    });

    // Clear the background image on initialization
    const featuredLinksImage = document.querySelector('.featured-links-image');
    if (featuredLinksImage) {
      const backgroundFade = featuredLinksImage.querySelector('.background-fade');
      if (backgroundFade) {
        backgroundFade.style.backgroundImage = 'none';
      }
    }

    // If the current item is the initially active one, set the background image immediately
    if (index === activeIndex) {
      if (featuredLinksImage) {
        const backgroundFade = featuredLinksImage.querySelector('.background-fade');
        if (backgroundFade) {
          backgroundFade.style.backgroundImage = `url(${item.getAttribute('data-image')})`;
        }
      }
    }
  });
};

const toggleAccordion = (index) => {
  const accordionItems = document.querySelectorAll('.accordion-item');
  accordionItems.forEach((item, i) => {
    const accordionTitle = item.querySelector('.accordion-title');
    const accordionContent = item.querySelector('.accordion-content');

    if (i === index) {
      item.classList.toggle('active');
      accordionTitle.classList.toggle('active');
      accordionContent.classList.toggle('active');
    } else {
      item.classList.remove('active');
      accordionTitle.classList.remove('active');
      accordionContent.classList.remove('active');
    }
  });
};

export { initAccordion };
